import { render, staticRenderFns } from "./LeadSalesEfficiencyDashboard.vue?vue&type=template&id=bbbba61a"
import script from "./LeadSalesEfficiencyDashboard.vue?vue&type=script&lang=js"
export * from "./LeadSalesEfficiencyDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports